import { useEffect, useRef, useState } from 'react'

/**
 * Exposes a ref object that can be passed to a component you want to disappear
 * when clicking anywhere outside of it
 *
 * @param {boolean} initialIsVisible - is the component initially visible
 * @returns {MutableRefObject<null>} ref - a ref you can pass to any component
 * @returns {boolean} isComponentVisible
 * @returns {Dispatch<SetStateAction<boolean>>} setIsComponentVisible
 */
export default function useComponentVisible(initialIsVisible: boolean) {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible)
  const ref = useRef<HTMLDivElement>(null)

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as HTMLDivElement)) {
      setIsComponentVisible(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [])

  return { ref, isComponentVisible, setIsComponentVisible }
}
